import React, { useState } from 'react';
// import CryptoJS from 'crypto-js';
// const SECRET_KEY = 'your-32-byte-secret'; 

// export const encryptData = (data) => {
//   const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
//   return ciphertext;
// };

// export const decryptData = (ciphertext) => {
//   try {
//     const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
//     const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//     return decryptedData;
//   } catch (e) {
//     console.error('Decryption failed:', e);
//     return ciphertext; // fallback if not encrypted
//   }
// };


export const getTags = (tagArray) => {
  return tagArray.map((tag, idx) => (
    `${tag} `
  ));
};

export const formatDate = (dateString, needTime = true) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const yyyy = date.getFullYear();
  const hh = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  const ss = String(date.getSeconds()).padStart(2, '0');
  const finalhh = hh > 12 ? hh - 12 : hh;
  const isAm = hh < 12 ? 'AM' : 'PM';
  if (!needTime) return `${dd}/${mm}/${yyyy}`;
  return (<span>
    <span>{`${dd}/${mm}/${yyyy}`}</span><br />
    <span style={{ color: 'rgba(15, 15, 15, .40)', fontWeight: 'normal' }}>{`(${finalhh}:${min} ${isAm})`}</span>
  </span>)
};
export const getAlphabetFromIndex = (index) => {
  if (index >= 0 && index < 26) {
    return String.fromCharCode(65 + index);
  }
  return '';
};
export const checkVideoPath = (videoUrl) => {
  if (videoUrl && videoUrl.includes('https://')) {
    return true;
  } else {
    return false;
  }
}

export const downloadFile = async (fileURL, fileName) => {
  try {
    if (!fileName) {
      fileName = fileURL.split('/').pop() || 'download';
    }
    const response = await fetch(fileURL, { mode: 'cors' });
    if (!response.ok) throw new Error('Network response was not ok');
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Download failed:', error);
  }
}
export const downloadFromData = async (dataToDownload, fileName) => {
  try {
    const blob = new Blob([dataToDownload], { type: 'application/octet-stream' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Download failed:', error);
  }
}
export const scrollToTop = (hasElement) => {
  if (typeof document === 'undefined') return;
  if (hasElement) {
    const el = document.getElementsByClassName(hasElement)[0] || document.querySelector(`.${hasElement}`);
    if (el && typeof el.scrollTo === 'function') {
      el.scrollTo({ behavior: 'smooth', top: 0 });
      return;
    }
  }
  if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}
export const secToHourMin = (durationinsec) => {
  if (!durationinsec || isNaN(durationinsec) || durationinsec < 0) return '00:00:00';
  const hours = Math.floor(durationinsec / 3600);
  const minutes = Math.floor((durationinsec % 3600) / 60);
  const seconds = Math.floor(durationinsec % 60);
  const totaltime = hours > 0 ? `${hours.toString().padStart(2, '0')}hr ` : minutes > 0 ? `${minutes.toString().padStart(2, '0')}min ${seconds.toString().padStart(2, '0')}sec` : `${seconds.toString().padStart(2, '0')}sec`;
  return totaltime;
}
export const getOverAllRating = (totalField, styleProps) => {
  const stars = [];
  const fullStars = Math.floor(totalField);
  const hasHalfStar = totalField - fullStars >= 0.5;
  for (let i = 0; i < 5; i++) {
    if (i < fullStars) {
      stars.push(
        <i
          key={i}
          className="fa fa-star"
          style={{
            color: "#ff6600",
            marginRight: 2,
            verticalAlign: 'middle',
            textShadow: '0 0 1px #ff6600',
            ...styleProps
          }}
          aria-hidden="true"
        />
      );
    } else if (i === fullStars && hasHalfStar) {
      stars.push(
        <i
          key={i}
          className="fa fa-star-half-o"
          style={{
            color: "#ff6600",
            marginRight: 2,
            verticalAlign: 'middle',
            textShadow: '0 0 1px #ff6600',
            ...styleProps
          }}
          aria-hidden="true"
        />
      );
    } else {
      stars.push(
        <i
          key={i}
          className="fa fa-star-o"
          style={{
            color: "#dbd7d6ff",
            marginRight: 2,
            verticalAlign: 'middle',
            textShadow: '0 0 1px #dbd7d6ff',
            ...styleProps
          }}
          aria-hidden="true"
        />
      );
    }
  }
  return stars;
}
export const setRating = (totalField, updateStart,styleProps) => {
  const stars = [];
  const fullStars = Math.floor(totalField);
  const hasHalfStar = totalField - fullStars >= 0.5;
  for (let i = 0; i < 5; i++) {
    if (i < fullStars) {
      stars.push(
        <i
          key={i}
          className="fa fa-star"
          style={{
            color: "#ff6600",
            marginRight: 2,
            verticalAlign: 'middle',
            textShadow: '0 0 1px #ff6600',
            cursor:'pointer',
            ...styleProps
          }}
          aria-hidden="true"
          onClick={() => updateStart(i + 1)}
        />
      );
    }else if (i === fullStars && hasHalfStar) {
      stars.push(
        <i
          key={i}
          className="fa fa-star-half-o"
          style={{
            color: "#ff6600",
            marginRight: 2,
            verticalAlign: 'middle',
            textShadow: '0 0 1px #ff6600',
            ...styleProps
          }}
          aria-hidden="true"
           onClick={() => updateStart(i + 1)}
        />
      );
    } else {
      stars.push(
        <i
          key={i}
          className="fa fa-star-o"
          style={{
            color: "#dbd7d6ff",
            marginRight: 2,
            verticalAlign: 'middle',
            textShadow: '0 0 1px #dbd7d6ff',
            cursor:'pointer',
            ...styleProps
          }}
          aria-hidden="true"
          onClick={() => updateStart(i + 1)}
        />
      );
    }
  }
  return stars;
}
export const getRandomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
export const levelConfig = [
  { value: 'beginner', label: 'Beginner' },
  { value: 'intermediate', label: 'Intermediate' },
  { value: 'advanced', label: 'Advanced' }
]
export const organisation = [
  { value: '01', label: 'Institutions' },
  { value: '02', label: 'SAMETIs' },
  { value: '03', label: 'FPOs' },
  { value: '04', label: 'NGOs/CBOs' },
  { value: '05', label: 'CSC Officers' },
  { value: '06', label: 'CSC-VLEs' },
  { value: '07', label: 'KRPH' },
  { value: '08', label: 'Bank' },
  { value: '09', label: 'Famers' },
  { value: '11', label: 'Insurance Company' },
  { value: '10', label: 'Others' },
]
export const getOrganisationLabel = (organisationValue) => {
  const org = organisation.find(org => org.value === organisationValue);
  return org ? org.label : null;
}
export const institutions = [
  { value: '01', label: 'MANAGE, Hyderabad' },
  { value: '02', label: 'NIA, Pune' },
  { value: '03', label: 'BIRD, Lucknow' },
  { value: '04', label: 'LINAC, Gurugram' },
  { value: '05', label: 'NCCT, New Delhi' },
  { value: '06', label: 'IRMA, Anand' },
  { value: '08', label: 'University/college' },
  { value: '07', label: 'Others' },
]
export const IC = [
  // { value: '01', label: 'HDFC ERGO General Insurance' },
  // { value: '02', label: 'ICICI Lombard General Insurance' },
  // { value: '03', label: 'Bajaj Allianz General Insurance' },
  // { value: '04', label: 'Future Generali India Insurance' },
  // { value: '05', label: 'IFFCO-Tokio General Insurance' },
  // { value: '06', label: 'Reliance General Insurance' },
  // { value: '07', label: 'Tata AIG General Insurance' },
  // { value: '08', label: 'Cholamandalam MS General Insurance' },
  // { value: '09', label: 'Universal Sompo General Insurance' },
  // { value: '10', label: 'SBI General Insurance' },
  { value: '1020', label: 'KSHEMA GENERAL INSURANCE LIMITED', ID: '1F36D593-E40E-4603-A1B1-C1E8C497E7D1' },
  { value: '1007', label: 'IFFCO TOKIO GENERAL INSURANCE CO. LTD.', ID: '370CE721-FCF9-4088-B769-EFE416336A70' },
  { value: '1002', label: 'CHOLAMANDALAM MS GENERAL INSURANCE COMPANY LIMITED', ID: '5B21F95D-6033-473F-BDEB-46DFA93BC37B' },
  { value: '1009', label: 'ICICI LOMBARD GENERAL INSURANCE CO. LTD.', ID: '82A6E862-91E4-4BE4-86C1-D04A60D9D562' },
  { value: '1006', label: 'HDFC ERGO GENERAL INSURANCE CO. LTD.', ID: '8F92B39E-F7DD-4021-8782-03FAF3EB00A1' },
  { value: '1004', label: 'BAJAJ GENERAL INSURANCE LTD', ID: 'AED99B42-6EE5-47A7-A637-730EB24563B8' },
  { value: '1003', label: 'IndusInd GIC', ID: 'BA4A0759-45F1-4EC3-BF08-1C28CC9949BD' },
  { value: '1010', label: 'TATA AIG GENERAL INSURANCE CO. LTD.', ID: 'C932B544-409E-4A34-9AFB-128DA423E947' },
  { value: '1008', label: 'UNIVERSAL SOMPO GENERAL INSURANCE COMPANY', ID: 'DA21FAC5-5E58-4EBE-81BB-2B96DD4D3A29' },
  { value: '1012', label: 'SBI GENERAL INSURANCE', ID: 'FE754761-1650-40EF-B4CE-DD5EAFF04478' },
  { value: '1001', label: 'AGRICULTURE INSURANCE COMPANY', ID: 'FB066A4B-1C1B-4467-B107-57B263911149' },
  { value: '1016', label: 'NATIONAL INSURANCE COMPANY LIMITED', ID: '276CD213-DE68-4333-B4E8-492443494656' },
  { value: '1018', label: 'ROYAL SUNDARAM GENERAL INSURANCE CO. LIMITED', ID: '2ABE4BBC-3060-4BA5-9B40-65370DEB0D1D' },
  { value: '1017', label: 'SHRIRAM GENERAL INSURANCE CO. LTD.', ID: '3886BBC9-85DA-425A-8B26-A49B93DDEAD8' },
  { value: '1013', label: 'UNITED INDIA INSURANCE CO.', ID: '5B0E7CBC-E383-410F-8D47-AAFB16DE2F5D' },
  // { value: '1019', label: 'BHARTI AXA GENERAL INSURANCE COMPANY LTD.', ID: '70C1D1CF-6BF3-49A0-9765-192464B882DA' },
  { value: '1021', label: 'GODIGIT GENERAL INSURANCE', ID: '70D78572-1305-4786-AC4A-BA6533582B90' },
  { value: '1014', label: 'NEW INDIA ASSURANCE COMPANY', ID: '8501AE91-898E-4D46-B6F4-6CB70E6AC635' },
  { value: '1015', label: 'ORIENTAL INSURANCE', ID: '9A02DE3E-04CB-4293-8C91-1ED779834C53' },
  { value: '1005', label: 'GENERALI CENTRAL INSURANCE COMPANY LTD.', ID: 'D19CD684-BCCB-4575-BC6B-0687572B0D3F' },


]
export const categary = [
  { value: '0001', label: 'General Courses (open for all)' },
  { value: '0002', label: 'Policy & Implementation (Government Officials)' },
  { value: '0003', label: 'Banking & Financial Institutions (Banking officials)' },
  { value: '0004', label: 'Insurance Operations & field implementation' },
  { value: '0005', label: 'Krishi Rakshak Portal & Helpline (KRPH)' },
  { value: '0006', label: 'Enrollment & Facilitation (CSCs, VLEs, and other Enrollment Agents)' },
]

export const lmsConfig = {
  totalQuestionToShow: 10,
  otpWaitTime: 300,
}
export const setSession = (sessionKey, value) => {
  sessionStorage.setItem(sessionKey, JSON.stringify(value));
};
export const removeSession = (sessionKey) => {  
  sessionStorage.removeItem(sessionKey);
};
export const getSession = (sessionKey) => {
  const stored = sessionStorage.getItem(sessionKey);
  return stored
    ? JSON.parse(stored)
    : null;
};
export const getCourseLessonCountByType = (lessons, type) => {
  if (!lessons || !Array.isArray(lessons)) return 0;
  return lessons.filter(lesson => lesson.type === type).length;
}

export const useImageWithFallback = (src, fallback) => {
  // console.log("🚀 krishna  ~ src, fallback:", src, fallback);

  const [imgSrc, setImgSrc] = useState(src);
  const handleError = () => setImgSrc(fallback);
  return [imgSrc, handleError];
}
export const scrollToSection = (id) => {
  const section = document.getElementById(id);
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
};
export const shuffleArray = (array) => {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}
export const DownLoadFromUrl = (base,) => {
  const url = `${process.env.REACT_APP_API_URL}${base}`;
  window.open(url, '_blank', 'noopener,noreferrer');
}
export const isSamePath = (location, path) => {
  const normalize = (p) => (p || '/').replace(/\/+$|^\s+|\s+$/g, '').replace(/\/$/, '') || '/';
  return normalize(location.pathname) === normalize(path);
}
export const isStrongPassword = (password) => {
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialChar = /[@#\$%\^&\+=]/.test(password);
  return password.length >= minLength && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar;
}
export const getLabelbyValue = (data, value, valueField, labelField) => {
  const option = data.find(opt => opt[valueField].toString() === value.toString());
  return option ? option[labelField] : null;
}
export const isEmpty = (obj) => {
  if (obj == null) return true; 
  return Object.keys(obj).length === 0;
};
export const findValueInArray=(data,findData,findOnKey)=>{
  const option = data.find(opt => opt[findOnKey].toString() === findData.toString());
  return !isEmpty(option);
}
export const maskMobile = (num) => {
  const s = String(num || '');
  if (!s) return '';
  if (s.length <= 4) return s;
  return '#'.repeat(s.length - 4) + s.slice(-4);
};
export const CreateUniqGoID = () => {
  const timestamp = Date.now().toString(36);
  const randomNum = Math.floor(Math.random() * 1e8).toString(36); 
  return `${timestamp}${randomNum}`.toUpperCase();
};

export const FixDecimalPlace = (value, toFix = 2) => {
  const num = Number(value);
  if (Number.isNaN(num)) return '';
  return num.toFixed(toFix);
};
export const convertNumberToKM = (numberData) => {
  const num = Number(numberData);
  if (isNaN(num)) return '';
  if (num >= 1e6) {
    return (num / 1e6).toFixed(num % 1e6 === 0 ? '' : 2) + 'M';
  } else if (num >= 1e3) {
    return (num / 1e3).toFixed(num % 1e3 === 0 ? '' : 2) + 'K';
  } else {
    return num.toString();
  }
};
export const isMobileDevice = () => {
  if (typeof window === 'undefined') return false;
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
};
export const getInitialName = (name) => {
        if (!name) return '';
        const nameParts = name.trim().split('_');
        if (nameParts.length === 1) {
            return nameParts[0].charAt(0).toUpperCase();
        } else {
            return (nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
        }
    }